module.exports = __webpack_public_path__ + "img/italy-flag.375ad085.svg";